import React from 'react';
import classnames from 'classnames';

import "./advanced-menu-button.scss";

export interface IProps {
    id: number;

    onChangeTitle?: () => void;
    onDelete?: () => void;
    onReorder?: () => void;

    emailTitle?: string;
    share?: () => Promise<string>;
    
    width?: number;
    height?: number;
}

export interface IState {
    isMenuOpen: boolean;

    share: {
        isFetching: boolean;
        link: string;
        isShowingCopiedMessage: boolean
    },

    emailStatus: {
        isFetching: boolean;
        link: string;
    }
}

export class AdvancedMenuButton extends React.Component <IProps, IState> {
    private root: HTMLElement;
    private menu: HTMLElement;
    private hasBeenMounted: boolean;
    
    constructor(props: IProps) {
        super(props);

        this.onRef = this.onRef.bind(this);
        this.onMenuRef = this.onMenuRef.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onMainButtonClick = this.onMainButtonClick.bind(this);
        this.onCopyLinkClick = this.onCopyLinkClick.bind(this);
        this.onEmailClick = this.onEmailClick.bind(this);
        this.onCopyLinkFromInput = this.onCopyLinkFromInput.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onChangeTitle = this.onChangeTitle.bind(this);
        this.onReorderClick = this.onReorderClick.bind(this);

        this.state = {
            isMenuOpen: false,
            share: {
                isFetching: false,
                isShowingCopiedMessage: false,
                link: ""
            },
            emailStatus: {
                isFetching: false,
                link: ""
            }
        };
    }

    public render(){
        const width = this.props.width || 18;
        const height = this.props.height || 24;
        
        return <div className={classnames("advanced-menu-button-root", {"_menu-opened": this.state.isMenuOpen})} ref={this.onRef}>
                    <button onClick={this.onMainButtonClick}>
                        <svg width={width} height={height} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.5 13.3564C13.0523 13.3564 13.5 12.9087 13.5 12.3564C13.5 11.8042 13.0523 11.3564 12.5 11.3564C11.9477 11.3564 11.5 11.8042 11.5 12.3564C11.5 12.9087 11.9477 13.3564 12.5 13.3564Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M19.5 13.3564C20.0523 13.3564 20.5 12.9087 20.5 12.3564C20.5 11.8042 20.0523 11.3564 19.5 11.3564C18.9477 11.3564 18.5 11.8042 18.5 12.3564C18.5 12.9087 18.9477 13.3564 19.5 13.3564Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M5.5 13.3564C6.05228 13.3564 6.5 12.9087 6.5 12.3564C6.5 11.8042 6.05228 11.3564 5.5 11.3564C4.94772 11.3564 4.5 11.8042 4.5 12.3564C4.5 12.9087 4.94772 13.3564 5.5 13.3564Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                    { this.renderMenu()}
               </div>
    }

    private renderMenu(){
        if(!this.state.isMenuOpen) { 
            document.removeEventListener("click", this.onDocumentClick);
            document.removeEventListener("keydown", this.onKeyDown);
            return null; 
        }
        
        return <div className="_menu" ref={this.onMenuRef}>
                    { this.renderChangeTitle()}
                    { this.renderLinkButton() }
                    { this.renderEmailButton()}
                    { this.renderDeleteButton()}
                    { this.renderReorderButton() }
                    <div className="_menu-tip"></div>
                </div>
    }

    private renderChangeTitle(){
        if(!this.props.onChangeTitle) { return null; }

        return <button onClick={this.onChangeTitle}>
                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.474 3.40783L15.592 5.52483L13.474 3.40783ZM14.836 1.54283L9.109 7.26983C8.81309 7.56533 8.61128 7.94181 8.529 8.35183L8 10.9998L10.648 10.4698C11.058 10.3878 11.434 10.1868 11.73 9.89083L17.457 4.16383C17.6291 3.99173 17.7656 3.78742 17.8588 3.56256C17.9519 3.33771 17.9998 3.09671 17.9998 2.85333C17.9998 2.60994 17.9519 2.36895 17.8588 2.14409C17.7656 1.91923 17.6291 1.71492 17.457 1.54283C17.2849 1.37073 17.0806 1.23421 16.8557 1.14108C16.6309 1.04794 16.3899 1 16.1465 1C15.9031 1 15.6621 1.04794 15.4373 1.14108C15.2124 1.23421 15.0081 1.37073 14.836 1.54283V1.54283Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M16 13V16C16 16.5304 15.7893 17.0391 15.4142 17.4142C15.0391 17.7893 14.5304 18 14 18H3C2.46957 18 1.96086 17.7893 1.58579 17.4142C1.21071 17.0391 1 16.5304 1 16V5C1 4.46957 1.21071 3.96086 1.58579 3.58579C1.96086 3.21071 2.46957 3 3 3H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    change title
                </button>
    }

    private renderDeleteButton(){
        if(!this.props.onDelete) { return null; }

        return <button className='_delete-button' onClick={this.onDelete}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 6H5H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M10 11V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M14 11V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>

                    delete
                </button>
    }

    private renderLinkButton(){
        if(!this.props.share) { return null; }
        
        if(this.state.share.isFetching){
            return <div className="_menu-item">
                        fetching link <i className="fa fa-spin fa-spinner"></i>
                    </div>
        }

        if(this.state.share.link){
            return <div className="_menu-item _input-field-row">
                        <input type="text" value={this.state.share.link} readOnly={true} ref={(e) => e && e.focus()}/>
                        <button title="copy" onClick={this.onCopyLinkFromInput}>
                            <i className={classnames("fa", {"fa-copy": !this.state.share.isShowingCopiedMessage, "fa-check": this.state.share.isShowingCopiedMessage})}></i>
                        </button>
                    </div>
        }
        
        return <button onClick={this.onCopyLinkClick}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.2 6C16.2 5.44772 16.6477 5 17.2 5C17.8367 5 18.4624 5.12794 19.0714 5.37152C19.7341 5.63661 20.2442 6.03001 20.7071 6.49289C21.17 6.95578 21.5634 7.4659 21.8285 8.12861C22.0721 8.73756 22.2 9.36326 22.2 10C22.2 10.6367 22.0721 11.2624 21.8285 11.8714C21.5667 12.5258 21.1798 13.0314 20.7245 13.4897L19.7399 14.5727C19.7293 14.5844 19.7183 14.5959 19.7071 14.6071L16.5071 17.8071C16.0442 18.27 15.5341 18.6634 14.8714 18.9285C14.2624 19.1721 13.6367 19.3 13 19.3C12.3633 19.3 11.7376 19.1721 11.1286 18.9285C10.4659 18.6634 9.95578 18.27 9.49289 17.8071C9.03 17.3442 8.63661 16.8341 8.37152 16.1714C8.12326 15.5507 8 14.9244 8 14.2C8 13.5633 8.12794 12.9376 8.37152 12.3286C8.63661 11.6659 9.03 11.1558 9.49289 10.6929L10.5929 9.59289C10.9834 9.20237 11.6166 9.20237 12.0071 9.59289C12.3976 9.98342 12.3976 10.6166 12.0071 11.0071L10.9071 12.1071C10.57 12.4442 10.3634 12.7341 10.2285 13.0714C10.0721 13.4624 10 13.8367 10 14.2C10 14.6756 10.0767 15.0493 10.2285 15.4286C10.3634 15.7659 10.57 16.0558 10.9071 16.3929C11.2442 16.73 11.5341 16.9366 11.8714 17.0715C12.2624 17.2279 12.6367 17.3 13 17.3C13.3633 17.3 13.7376 17.2279 14.1286 17.0715C14.4659 16.9366 14.7558 16.73 15.0929 16.3929L18.2761 13.2097L19.2601 12.1273C19.2707 12.1156 19.2817 12.1041 19.2929 12.0929C19.63 11.7558 19.8366 11.4659 19.9715 11.1286C20.1279 10.7376 20.2 10.3633 20.2 10C20.2 9.63674 20.1279 9.26244 19.9715 8.87139C19.8366 8.5341 19.63 8.24422 19.2929 7.90711C18.9558 7.56999 18.6659 7.36339 18.3286 7.22848C17.9376 7.07206 17.5633 7 17.2 7C16.6477 7 16.2 6.55228 16.2 6ZM11.3 7.5C10.9367 7.5 10.5624 7.57206 10.1714 7.72848C9.8341 7.86339 9.54422 8.07 9.20711 8.40711L5.92393 11.6903L4.93994 12.7727C4.92927 12.7844 4.91832 12.7959 4.90711 12.8071C4.56999 13.1442 4.36339 13.4341 4.22848 13.7714C4.07206 14.1624 4 14.5367 4 14.9C4 15.2633 4.07206 15.6376 4.22848 16.0286C4.36339 16.3659 4.57 16.6558 4.90711 16.9929C5.24422 17.33 5.5341 17.5366 5.87139 17.6715C6.26244 17.8279 6.63674 17.9 7 17.9C7.55228 17.9 8 18.3477 8 18.9C8 19.4523 7.55228 19.9 7 19.9C6.36326 19.9 5.73756 19.7721 5.12861 19.5285C4.4659 19.2634 3.95578 18.87 3.49289 18.4071C3.03 17.9442 2.63661 17.4341 2.37152 16.7714C2.12794 16.1624 2 15.5367 2 14.9C2 14.2633 2.12794 13.6376 2.37152 13.0286C2.63328 12.3742 3.02016 11.8686 3.47551 11.4103L4.46006 10.3273C4.47073 10.3156 4.48168 10.3041 4.49289 10.2929L7.79289 6.99289C8.25578 6.53 8.7659 6.13661 9.42861 5.87152C10.0376 5.62794 10.6633 5.5 11.3 5.5C11.9367 5.5 12.5624 5.62794 13.1714 5.87152C13.8341 6.13661 14.3442 6.53 14.8071 6.99289C15.27 7.45578 15.6634 7.9659 15.9285 8.62861C16.1721 9.23756 16.3 9.86326 16.3 10.5C16.3 11.1367 16.1721 11.7624 15.9285 12.3714C15.6664 13.0265 15.279 13.5325 14.823 13.9912L13.7372 15.1757C13.364 15.5828 12.7314 15.6103 12.3243 15.2372C11.9172 14.864 11.8897 14.2314 12.2628 13.8243L13.3628 12.6243C13.3726 12.6136 13.3827 12.6031 13.3929 12.5929C13.73 12.2558 13.9366 11.9659 14.0715 11.6286C14.2279 11.2376 14.3 10.8633 14.3 10.5C14.3 10.1367 14.2279 9.76244 14.0715 9.37139C13.9366 9.0341 13.73 8.74422 13.3929 8.40711C13.0558 8.07 12.7659 7.86339 12.4286 7.72848C12.0376 7.57206 11.6633 7.5 11.3 7.5Z" fill="currentColor"/>
                    </svg>
                    copy link
               </button>
    }

    private renderEmailButton(){
        if(!this.props.emailTitle) { return null; }
        
        if(this.state.emailStatus.isFetching){
            return <div className="_menu-item">
                        fetching link <i className="fa fa-spin fa-spinner"></i>
                    </div>
        }

        if(this.state.emailStatus.link){
            return <a href={`mailto:?subject=${this.props.emailTitle}&body=${this.state.emailStatus.link}`} target="_blank">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z" fill="currentColor"/>
                        </svg>
                        send email
                    </a>
        }
        
        return <button onClick={this.onEmailClick}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z" fill="currentColor"/>
                    </svg>
                    email
                </button>
    }

    private renderReorderButton(){
        if(!this.props.onReorder) { return null; }
        
        return <button onClick={this.onReorderClick}>
                    <i className='fa fa-sort reorder-icon'></i>
                    reorder
                </button>
    }

    public componentDidMount(){
        this.hasBeenMounted = true;
        
        document.addEventListener("keydown", this.onKeyDown);
        document.addEventListener("click", this.onDocumentClick);
    }

    public componentWillUnmount(){
        this.hasBeenMounted = false;

        document.removeEventListener("keydown", this.onKeyDown);
        document.removeEventListener("click", this.onDocumentClick);
    }

    private onRef(root: HTMLElement){
        this.root = root;
    }

    private onMenuRef(menu: HTMLElement){
        if(!this.menu && menu){
            document.addEventListener("click", this.onDocumentClick);
            document.addEventListener("keydown", this.onKeyDown);
        }

        if(this.menu && !menu){
            document.removeEventListener("click", this.onDocumentClick);
            document.removeEventListener("keydown", this.onKeyDown);
        }
        
        this.menu = menu;
    }

    private onMainButtonClick(){
        this.setState({
            isMenuOpen: !this.state.isMenuOpen
        });
    }

    private onCopyLinkClick(){
        //If I don't do it in a timeout,
        //the copy button gets detached and the onDocument click handler
        //doesn't recognize it as a part of the subtree
        setTimeout(() => {
            this.setState({
                share: {
                    isFetching: true,
                    isShowingCopiedMessage: false,
                    link: ""
                } 
            });
                        
            this.props.share().then((link: string) => {
                this.setState({
                    share: {
                        isFetching: false,
                        isShowingCopiedMessage: false,
                        link: link
                    } 
                });
            }).catch(() => {
                alert("Couldn't generate the share link. Try again later.")
                this.setState({
                    share: {
                        isFetching: false,
                        isShowingCopiedMessage: false,
                        link: ""
                    } 
                });
            });
        }, 16);
    }

    private onEmailClick(){
        setTimeout(() => {
            this.setState({
                emailStatus: {
                    isFetching: true,
                    link: ""
                } 
            });
            
            this.props.share().then((link: string) => {
                this.setState({
                    emailStatus: {
                        isFetching: false,
                        link: link
                    } 
                });
            }).catch(() => {
                alert("Couldn't generate the share link. Try again later.")
                this.setState({
                    emailStatus: {
                        isFetching: false,
                        link: ""
                    } 
                });
            });
        }, 16);
    }

    private onKeyDown(e){
        if(!this.hasBeenMounted || !this.state.isMenuOpen) { return;  }
        
        if((e.keyCode || e.which) == 27){
            this.setState({
                isMenuOpen: false
            });
        }
    }

    private onDocumentClick(e){
        if(!this.hasBeenMounted || !this.state.isMenuOpen) { return;  }
        
        if(this.root != null){
            if(this.menu != e.target 
            && !this.menu.contains(e.target)
            && !this.root.contains(e.target)){
                this.setState({
                    isMenuOpen: false
                });
            }
        }
    }

    private onCopyLinkFromInput(e){
        const target: HTMLElement = e.currentTarget;
        if(target != null && target.parentElement != null){
            const input = target.parentElement.querySelector("input") as HTMLInputElement;

            input.select();
            input.setSelectionRange(0, 99999); /* For mobile devices */

            /* Copy the text inside the text field */
            navigator.clipboard.writeText(input.value);

            this.setState({
                share: {
                    isFetching: false,
                    link: this.state.share.link,
                    isShowingCopiedMessage: true
                }
            });

            setTimeout(() => {
                if(!this.hasBeenMounted) { return; }

                this.setState({
                    share: {
                        isFetching: false,
                        link: this.state.share.link,
                        isShowingCopiedMessage: false
                    }
                });
            }, 2000);
        }
    }

    private onDelete(e){
        if(!this.props.onDelete) { return; }

        this.setState({
            isMenuOpen: false
        });

        setTimeout(() => this.props.onDelete(), 16);
    }

    private onChangeTitle(e){
        if(!this.props.onChangeTitle) { return; }

        this.setState({
            isMenuOpen: false
        });

        setTimeout(() => this.props.onChangeTitle(), 16);
    }

    private onReorderClick(e){
        if(!this.props.onReorder) { return; }

        this.setState({
            isMenuOpen: false
        });

        setTimeout(() => this.props.onReorder(), 16);
    }
}